<div [hidden]="!(httpStatus.getHttpStatus() | async)" class="loading-data">
    <img src="../../../../../assets/loader/loader.svg" />
</div>